import { render, staticRenderFns } from "./BackgroundColor.vue?vue&type=template&id=ec0d1876&"
import script from "./BackgroundColor.vue?vue&type=script&lang=js&"
export * from "./BackgroundColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports